import React from 'react';
import { Upload, message } from 'antd';
import { Storage } from 'aws-amplify';
import compose from 'lodash/flowRight';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import CREATE_MEDIA_ADMIN from '../../../../core/GraphQl/Mutations/CREATE_MEDIA_ADMIN';
import { campaignTypeMap } from '../../../../core/utils/constants/constants';
import { getUploadedFileDimensions } from '../../../../core/utils/dataManipulating/images';

const BannerUploader = ({ adUnit, button, index, bulkCreateCreatives, type: campaignType }) => {
  const medias = [];
  const invalidMedias = [];
  const uploaderProps = {
    name: 'file',
    action: null,
    multiple: true,
    beforeUpload: async (file, fileList) => {
      try {
        message.destroy();
        message.loading('Processing creatives...', 0);

        const { name, size, type } = file;

        if (campaignType !== campaignTypeMap.VIDEO && type === 'video/mp4') {
          message.destroy();
          message.error('File must be an image');
          return;
        }

        if (campaignType === campaignTypeMap.VIDEO && type !== 'video/mp4') {
          message.destroy();
          message.error('File must be mp4');
          return;
        }

        if (size > 2000000) {
          message.destroy();
          message.error("File can't exceed 2MB");
          return;
        }

        // Read image dimensions for the media record (videos have no dimensions)
        let imageWidth = 0;
        let imageHeight = 0;

        if (campaignType !== campaignTypeMap.VIDEO) {
          const dimensions = await getUploadedFileDimensions(file);
          imageWidth = dimensions.width;
          imageHeight = dimensions.height;
        }

        const fname = `${new Date().getTime()}-${file.name}`;
        const response = await Storage.put(fname, file, {
          contentType: 'image/*',
        });
        const { key } = response;
        const url = await Storage.get(response.key, { expires: 600000 });

        let fileType = key.split('.')[1].toUpperCase();

        medias.push({
          type: 'STILL',
          key,
          url,
          width: imageWidth,
          height: imageHeight,
          name,
          size,
          fileType,
        });

        const validFiles = fileList.filter((fList) => !invalidMedias.includes(fList.uid));

        if (medias.length === validFiles.length) {
          bulkCreateCreatives({ medias, invalidMedias, adUnitIndex: index });
        }
      } catch (error) {
        message.error('Error uploading file');
      }
    },
    showUploadList: false,
    accept: '.png, .jpeg, .jpg, .gif, .avif',
    customRequest: async () => {
      setTimeout(() => {
        return true;
      }, 0);
    },
  };
  return <Upload {...uploaderProps}>{button}</Upload>;
};

BannerUploader.propTypes = {
  image: PropTypes.object,
  onChangeArrayOfObj: PropTypes.func,
  adUnit: PropTypes.object,
  button: PropTypes.node,
  index: PropTypes.number,
  onChange: PropTypes.func,
  handleUpdateCampaignOrder: PropTypes.func,
};

export default compose(graphql(CREATE_MEDIA_ADMIN, { name: 'createMediaMutation' }))(
  BannerUploader
);
